import { EventMeta } from '../../../interfaces/meta.interface';

const recordDelete: EventMeta = {
    title: 'Record Deleted',
    default: {
        description: 'Record Deleted',
        longDescription:
            "An item that's labeled as a record was soft-deleted (moved to the Recoverable Items folder). Items labeled as records can't be permanently deleted.",
        severity: 'info',
    },
};

export default recordDelete;
